import type { ClinicalPlanKey } from "src/utils/plansMapping";

/**
 * Centralizes product names for product-switch-compatible med products.
 *
 * ### Usage
 * When creating a map object of product identifiers:
 * - Use the full mapping type to enforce that the feature supports all med product-switch-compatible products.
 * - Use a partial mapping to enforce that all products listed are med product-switch-compatible and that their identifiers are correctly written.
 * */
export const medProductSwitchProductNames = {
  compoundedMicrodose: "telehealth-medtier-compounded-microdose",
  compounded: "telehealth-medtier-compounded",
  compoundedTirzepatide: "telehealth-medtier-compounded-tirzepatide",
  compoundedMicrodoseTirzepatide:
    "telehealth-medtier-compounded-microdose-tirzepatide",
} as const satisfies Partial<Record<ClinicalPlanKey, string>>;

export type MedProductSwitchMap = typeof medProductSwitchProductNames;
export type MedProductSwitchKey = keyof MedProductSwitchMap;
export type MedProductSwitchProductName =
  MedProductSwitchMap[MedProductSwitchKey];
